import styled from '@emotion/styled'
import { Box, Card, Typography } from '@mui/material'
import { ConnectType, useWallet } from '@terra-money/wallet-provider'
import CoreModal from 'core/CoreModal'
import TerraStationLogo from 'assets/logos/terra-station-extension.png'
const CustomCard = styled(Card)`
  background: #f6f6f6;
  border-radius: 8px;
  height: 88px;
  padding: 32px;
  cursor: pointer;
  :hover {
    background: #eaeaea;
  }
`

const FlexList = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 32px;
`
interface Props {
  onClose: () => void
}

const WalletConnectorModal = ({ onClose }: Props) => {
  const { availableConnections, availableInstallTypes, connect, install } =
    useWallet()

  const onClickCard = (connectionType: ConnectType) => {
    connect(connectionType)
    onClose()
  }

  const AvailableForInstall = availableInstallTypes.includes(
    ConnectType.EXTENSION,
  ) && (
    <Box marginTop="32px">
      <Typography variant="h6" fontWeight={600}>
        Available for install
      </Typography>
      <FlexList>
        <CustomCard
          onClick={() => install(ConnectType.EXTENSION)}
          sx={{ display: 'flex', justifyContent: 'space-between' }}
        >
          <Typography variant="body1">Terra Station Extension</Typography>
          <img
            src={TerraStationLogo}
            alt="Terra station extension"
            width={32}
            height={32}
          />
        </CustomCard>
      </FlexList>
    </Box>
  )

  const Content = (
    <>
      <Typography variant="h6" fontWeight={600}>
        Connect to a wallet
      </Typography>
      <FlexList>
        {availableConnections.map(
          (connection) =>
            connection.type !== ConnectType.READONLY && (
              <CustomCard
                onClick={() => onClickCard(connection.type)}
                sx={{ display: 'flex', justifyContent: 'space-between' }}
                key={connection.name}
              >
                <Typography variant="body1">{connection.name}</Typography>
                <img
                  src={connection.icon}
                  alt={connection.name}
                  width={32}
                  height={32}
                />
              </CustomCard>
            ),
        )}
      </FlexList>
      {AvailableForInstall}
    </>
  )
  return <CoreModal open content={Content} onClose={onClose} />
}

export default WalletConnectorModal
